/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import AppBar from 'material-ui/AppBar'
import ArrowDropDown from 'material-ui-icons/ArrowDropDown'
import AssignmentIcon from 'material-ui-icons/Assignment'
import Button from 'material-ui/Button'
import { hasMembership, hasRole } from '../utils/helpers';
import Menu, { MenuItem } from 'material-ui/Menu'
import Messages from '../constants/messages'
import { nordAdmins, partnerAccessAdmin } from '../constants/memberships';
import PersonIcon from 'material-ui-icons/Person'
import PropTypes from 'prop-types'
import Toolbar from 'material-ui/Toolbar'
import Tooltip from 'material-ui/Tooltip'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  appName: PropTypes.string,
  classes: PropTypes.object.isRequired,
  isAssignmentButtonDisabled: PropTypes.bool.isRequired,
  firstName: PropTypes.string,
  heading: PropTypes.string,
  lastName: PropTypes.string,
  logout: PropTypes.func.isRequired,
  menuAnchorElement: PropTypes.object.isRequired,
  partners: PropTypes.array.isRequired,
  setMenuAnchorElement: PropTypes.func.isRequired,
  setShowProfileMenu: PropTypes.func.isRequired,
  showProfileMenu: PropTypes.bool.isRequired,
  userMemberships: PropTypes.array.isRequired,
  userRoles: PropTypes.array.isRequired
}

const drawerWidth = 240

const styles = theme => ({
  appBar: {
    position: 'absolute',
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    order: 1,
  },
  appName: {
    paddingLeft: '0.3em'
  },
  flex: {
    flex: 1,
  },
  assignmentButton: {
    color: 'white',
    minWidth: 0,
    width: 'auto'
  },
  menuItem: {
    minWidth: "7em"
  },
  partnersToolTip: {
    width: 200
  },
  partnersToolTipTitle: {
    display: 'block',
    fontSize: 14,
    marginBottom: 5,
    borderBottom: '1px solid #fff'
  },
  partnersToolTipPartner: {
    display: 'block',
    marginRight: 5
  },
  profileButton: {
    color: 'white'
  },
  profileMenu: {
    minWidth: "2em",
    right: "11em",
    width: "1em",
    left: 'auto'
  }
})

export class NordAppBar extends Component {

  handleClick(event) {
    const { setMenuAnchorElement, setShowProfileMenu } = this.props

    setMenuAnchorElement(event.currentTarget)
    setShowProfileMenu(true)
  }

  isProfileOptionAllowed() {
    const { userRoles } = this.props
    return hasRole(userRoles, partnerAccessAdmin)
  }

  renderAppContextInfo() {
    const { userMemberships, userRoles } = this.props
    let markup = null
    const isAdmin = hasMembership(userMemberships, nordAdmins) || hasRole(userRoles, partnerAccessAdmin)
    if(isAdmin) {
      markup = (
        <Tooltip
          PopperProps={{ style: { pointerEvents: 'none' } }}
          title={this.renderPartnersTooltip()}
          placement="bottom-end">
          { this.renderAssignmentButton() }
        </Tooltip>
      )
    }
    return markup
  }

  renderPartnersTooltip() {
    const { classes, partners } = this.props
    let markup = (<span>{Messages['uiComponents']['APP_CONTEXT_NO_PARTNERS']}</span>)

    if(partners.length > 0) {
      markup = (
        <div className={classes.partnersToolTip}>
          <span className={classes.partnersToolTipTitle}>Partner(s) Shown</span>
          {partners.map((partner, index) => {
            return (
              <span key={index} className={classes.partnersToolTipPartner}>{partner.name} - {partner.id}</span>
            )
          })}
        </div>
      )
    }

    return markup
  }

  renderAssignmentButton() {
    const { appName, changePage, classes, isAssignmentButtonDisabled, setShowContext } = this.props
    return (
      <Button
      disabled={isAssignmentButtonDisabled}
      data-test-id="assignmentButton"
      className={classes.assignmentButton}
      onClick={() => {
        setShowContext(true)
        changePage('/appContextDialog')
      }}>
        <AssignmentIcon /> <span data-test-id="app-name" className={classes.appName}>{appName}</span>
        {isAssignmentButtonDisabled ? null : <ArrowDropDown />}
      </Button>
    )
  }

  renderProfileMenuItem() {
    const { changePage, classes, setShowProfileMenu } = this.props
    return (
    <MenuItem
      data-test-id="profileNavButton"
      className={classes.menuItem}
      onClick={() => {
        setShowProfileMenu(false)
        changePage('/profile')
      }}>
      {Messages['uiComponents']['PROFILE_MENU_ITEM']}
    </MenuItem>
    )
  }

  render() {
    const {
      classes,
      firstName,
      heading,
      lastName,
      logout,
      menuAnchorElement,
      setShowProfileMenu,
      showProfileMenu } = this.props

    return (
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography data-test-id="heading" type="title" color="inherit" className={classes.flex}>
            {Messages['uiComponents']['APPLICATION_NAME']} - {heading}
          </Typography>
          {this.renderAppContextInfo()}
          <Button
            data-test-id="profileButton"
            aria-owns={showProfileMenu ? 'profile-menu' : null}
            aria-haspopup="true"
            className={classes.profileButton}
            onClick={(event) => this.handleClick(event)}>
            <PersonIcon /> <span data-test-id="login-name">{`${firstName} ${lastName}`}</span> <ArrowDropDown />
          </Button>
          <Menu
            id="profile-menu"
            anchorEl={menuAnchorElement}
            className={classes.profileMenu}
            open={showProfileMenu}
            onRequestClose={() => {setShowProfileMenu(false)}}>
            {this.isProfileOptionAllowed() ? this.renderProfileMenuItem() : null}
            <MenuItem
              data-test-id="logoutNavButton"
              className={classes.menuItem}
              onClick={() => {
                logout()
                .then(() => window.location = '/loggedOut')
              }}>
              {Messages['uiComponents']['LOGOUT_LABEL']}
            </MenuItem>
        </Menu>
        </Toolbar>
      </AppBar>
    )
  }
}

NordAppBar.propTypes = PROP_TYPES

export default withStyles(styles)(NordAppBar)
